import React from 'react';
import styled from 'styled-components';
import Slide from 'react-reveal/Slide';

import { Item } from '../styles/styles.js';

const TitleSeparator = styled.h2`
  margin-top: 30px;
  margin-left: 30px;
  color: #00a85a;
`;

const Bebidas = () => (
  <>
    <Slide left cascade duration={300}>
      <TitleSeparator>Refrigerantes</TitleSeparator>
    </Slide>

    <Item firstItem>
      <div className="item-separator">
        <h4 className="item-title">Refrigerante Lata</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>8,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Coca / Coca Zero 1L</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>12,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Coca / Coca Zero 2L</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>18,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Guaraná / Guaraná Zero 1.5L</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>13,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Sukita Laranja, Uva e Limão 2L</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>15,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Slide left cascade duration={300}>
      <TitleSeparator>Cervejas</TitleSeparator>
    </Slide>

    <Item firstItem>
      <div className="item-separator">
        <h4 className="item-title">Cerveja Skol/Brahma Lata</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>8,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Cerveja Spaten 600ml</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>16,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Cerveja Original 600ml</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>17,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Cerveja Heineken 600ml</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>18,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Slide left cascade duration={300}>
      <TitleSeparator>Suco</TitleSeparator>
    </Slide>

    <Item firstItem>
      <div className="item-separator">
        <h4 className="item-title">Suco copo 450ml</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>12,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Slide left cascade duration={300}>
      <TitleSeparator>Água</TitleSeparator>
    </Slide>

    <Item firstItem>
      <div className="item-separator">
        <h4 className="item-title">Água sem Gás 500ml</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>4,00</p>
          </div>
        </div>
      </div>
    </Item>

    <Item>
      <div className="item-separator">
        <h4 className="item-title">Água com Gás 500ml</h4>
      </div>

      <div className="item-price-container">
        <div className="item-price-wrapper">
          <div className="item-price">
            <p>5,00</p>
          </div>
        </div>
      </div>
    </Item>
  </>
);

export default Bebidas;
